export interface RegistrationOfficeName {
  surface: string;
  reading: string;
}

// Vehicle registration office names (運輸支局 / 自動車検査登録事務所) printed on
// every Japanese number plate. Mozc's stock dictionary does not include them,
// so without this list the customer cannot enter their own plate or log in.
// Source: https://en.wikipedia.org/wiki/Vehicle_registration_plates_of_Japan
export const REGISTRATION_OFFICE_NAMES: RegistrationOfficeName[] = [
  { surface: '尾張小牧', reading: 'おわりこまき' },
  { surface: '一宮', reading: 'いちのみや' },
  { surface: '春日井', reading: 'かすがい' },
  { surface: '名古屋', reading: 'なごや' },
  { surface: '豊橋', reading: 'とよはし' },
  { surface: '三河', reading: 'みかわ' },
  { surface: '岡崎', reading: 'おかざき' },
  { surface: '豊田', reading: 'とよた' },
  { surface: '秋田', reading: 'あきた' },
  { surface: '青森', reading: 'あおもり' },
  { surface: '弘前', reading: 'ひろさき' },
  { surface: '八戸', reading: 'はちのへ' },
  { surface: '千葉', reading: 'ちば' },
  { surface: '成田', reading: 'なりた' },
  { surface: '習志野', reading: 'ならしの' },
  { surface: '市川', reading: 'いちかわ' },
  { surface: '船橋', reading: 'ふなばし' },
  { surface: '野田', reading: 'のだ' },
  { surface: '柏', reading: 'かしわ' },
  { surface: '松戸', reading: 'まつど' },
  { surface: '袖ヶ浦', reading: 'そでがうら' },
  { surface: '市原', reading: 'いちはら' },
  { surface: '愛媛', reading: 'えひめ' },
  { surface: '福井', reading: 'ふくい' },
  { surface: '福岡', reading: 'ふくおか' },
  { surface: '筑豊', reading: 'ちくほう' },
  { surface: '北九州', reading: 'きたきゅうしゅう' },
  { surface: '久留米', reading: 'くるめ' },
  { surface: '福島', reading: 'ふくしま' },
  { surface: '会津', reading: 'あいづ' },
  { surface: '郡山', reading: 'こおりやま' },
  { surface: '白河', reading: 'しらかわ' },
  { surface: 'いわき', reading: 'いわき' },
  { surface: '岐阜', reading: 'ぎふ' },
  { surface: '飛騨', reading: 'ひだ' },
  { surface: '群馬', reading: 'ぐんま' },
  { surface: '前橋', reading: 'まえばし' },
  { surface: '高崎', reading: 'たかさき' },
  { surface: '福山', reading: 'ふくやま' },
  { surface: '広島', reading: 'ひろしま' },
  { surface: '旭川', reading: 'あさひかわ' },
  { surface: '函館', reading: 'はこだて' },
  { surface: '北見', reading: 'きたみ' },
  { surface: '知床', reading: 'しれとこ' },
  { surface: '釧路', reading: 'くしろ' },
  { surface: '室蘭', reading: 'むろらん' },
  { surface: '苫小牧', reading: 'とまこまい' },
  { surface: '帯広', reading: 'おびひろ' },
  { surface: '札幌', reading: 'さっぽろ' },
  { surface: '姫路', reading: 'ひめじ' },
  { surface: '神戸', reading: 'こうべ' },
  { surface: '水戸', reading: 'みと' },
  { surface: '土浦', reading: 'つちうら' },
  { surface: 'つくば', reading: 'つくば' },
  { surface: '石川', reading: 'いしかわ' },
  { surface: '金沢', reading: 'かなざわ' },
  { surface: '岩手', reading: 'いわて' },
  { surface: '平泉', reading: 'ひらいずみ' },
  { surface: '盛岡', reading: 'もりおか' },
  { surface: '香川', reading: 'かがわ' },
  { surface: '高松', reading: 'たかまつ' },
  { surface: '鹿児島', reading: 'かごしま' },
  { surface: '奄美', reading: 'あまみ' },
  { surface: '相模', reading: 'さがみ' },
  { surface: '湘南', reading: 'しょうなん' },
  { surface: '川崎', reading: 'かわさき' },
  { surface: '横浜', reading: 'よこはま' },
  { surface: '高知', reading: 'こうち' },
  { surface: '熊本', reading: 'くまもと' },
  { surface: '京都', reading: 'きょうと' },
  { surface: '三重', reading: 'みえ' },
  { surface: '鈴鹿', reading: 'すずか' },
  { surface: '四日市', reading: 'よっかいち' },
  { surface: '伊勢志摩', reading: 'いせしま' },
  { surface: '宮城', reading: 'みやぎ' },
  { surface: '仙台', reading: 'せんだい' },
  { surface: '宮崎', reading: 'みやざき' },
  { surface: '松本', reading: 'まつもと' },
  { surface: '諏訪', reading: 'すわ' },
  { surface: '長野', reading: 'ながの' },
  { surface: '長崎', reading: 'ながさき' },
  { surface: '佐世保', reading: 'させぼ' },
  { surface: '奈良', reading: 'なら' },
  { surface: '飛鳥', reading: 'あすか' },
  { surface: '長岡', reading: 'ながおか' },
  { surface: '上越', reading: 'じょうえつ' },
  { surface: '新潟', reading: 'にいがた' },
  { surface: '大分', reading: 'おおいた' },
  { surface: '岡山', reading: 'おかやま' },
  { surface: '倉敷', reading: 'くらしき' },
  { surface: '沖縄', reading: 'おきなわ' },
  { surface: '和泉', reading: 'いずみ' },
  { surface: '堺', reading: 'さかい' },
  { surface: '大阪', reading: 'おおさか' },
  { surface: 'なにわ', reading: 'なにわ' },
  { surface: '佐賀', reading: 'さが' },
  { surface: '春日部', reading: 'かすかべ' },
  { surface: '越谷', reading: 'こしがや' },
  { surface: '熊谷', reading: 'くまがや' },
  { surface: '大宮', reading: 'おおみや' },
  { surface: '川口', reading: 'かわぐち' },
  { surface: '所沢', reading: 'ところざわ' },
  { surface: '川越', reading: 'かわごえ' },
  { surface: '滋賀', reading: 'しが' },
  { surface: '島根', reading: 'しまね' },
  { surface: '出雲', reading: 'いずも' },
  { surface: '浜松', reading: 'はままつ' },
  { surface: '沼津', reading: 'ぬまづ' },
  { surface: '富士山', reading: 'ふじさん' },
  { surface: '伊豆', reading: 'いず' },
  { surface: '静岡', reading: 'しずおか' },
  { surface: 'とちぎ', reading: 'とちぎ' },
  { surface: '宇都宮', reading: 'うつのみや' },
  { surface: '那須', reading: 'なす' },
  { surface: '徳島', reading: 'とくしま' },
  { surface: '足立', reading: 'あだち' },
  { surface: '江東', reading: 'こうとう' },
  { surface: '葛飾', reading: 'かつしか' },
  { surface: '八王子', reading: 'はちおうじ' },
  { surface: '多摩', reading: 'たま' },
  { surface: '練馬', reading: 'ねりま' },
  { surface: '杉並', reading: 'すぎなみ' },
  { surface: '板橋', reading: 'いたばし' },
  { surface: '品川', reading: 'しながわ' },
  { surface: '世田谷', reading: 'せたがや' },
  { surface: '鳥取', reading: 'とっとり' },
  { surface: '富山', reading: 'とやま' },
  { surface: '和歌山', reading: 'わかやま' },
  { surface: '庄内', reading: 'しょうない' },
  { surface: '山形', reading: 'やまがた' },
  { surface: '山口', reading: 'やまぐち' },
  { surface: '下関', reading: 'しものせき' },
  { surface: '山梨', reading: 'やまなし' },
];
